import * as Yup from 'yup';
import { buildContactSupportPhoneField } from '../../utilities/validation/contactSupport.validation.schema';

const remedyForceSupportBaseFields = {
  summary: Yup.string()
    .label('Subject')
    .max(40, 'Subject is max 40 characters length')
    .required(),
  description: Yup.string()
    .label('Description')
    .max(250, 'Description is max 250 characters length')
    .required(),
  appAccessible: Yup.string().label('Access the application').required(),
  dataCorrupted: Yup.string().label('Data corrupted'),
  dbydReferrals: Yup.string().label('BYDA referrals'),
  category: Yup.string().label('Category').required(),
  name: Yup.string().label('Name').required(),
  email: Yup.string().label('Email').email('Invalid email address').required()
};

/**
 * @param hasProfilePhone - true when logged-in user already has phoneNumber on profile
 */
export const getRemedyForceSupportSchema = (hasProfilePhone: boolean) =>
  Yup.object().shape({
    ...remedyForceSupportBaseFields,
    phoneNumber: buildContactSupportPhoneField(!hasProfilePhone)
  });

/** @deprecated Use getRemedyForceSupportSchema(hasProfilePhone) */
export const ContactSupportSchema = getRemedyForceSupportSchema(false);
